/* shah */
import React from 'react'

const InkIcon = () => {
    return (
        <svg id="SmallBoxSVG-ink" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1075 1024" className="icon" style={{display: "inline-flex"}}>
            <path xmlns="http://www.w3.org/2000/svg"
                d="M600.448 25.866a54.539 54.539 0 0 0-92.785 0L243.01 454.098a375.146 375.146 0 0 0-34.597 72.305C123.718 766.229 295.517 1024 548.87 1024h10.373c253.353 0 425.149-257.772 340.454-497.597a375.201 375.201 0 0 0-34.596-72.305L600.448 25.866zm101.181 371.195c-2.852 2.882-5.765 5.911-8.796 9.062-23.27 24.196-53.402 55.526-114.698 81.796-102.809 44.059-178.74 25.407-216.865-17.703l192.785-311.942 147.574 238.788z"></path>
        </svg>
    )
}

export default InkIcon